import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getShopClient = async (domain: string, clientId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop-clients/${clientId}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true
    });
}